import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { getUserDisplayName } from "src/Utils/Common";

const ValueGrowthIndicator = ({ 
  title, 
  dataValues,  
  selectedLabel, 
  displayMode = "market"  
}) => {
  const isDataLoaded = () => {
    return dataValues && 
           dataValues.length > 0 && 
           dataValues[0] && 
           dataValues[0].data && 
           Array.isArray(dataValues[0].data) &&
           dataValues[0].data.length >= 2;
  };

  if (!isDataLoaded()) {
    return null;
  }

  const getValues = () => {
    const data = dataValues[0].data;
    return {
      firstValue: data[0] || 0,
      secondValue: data[1] || 0
    };
  };

  const { firstValue, secondValue } = getValues();
  
  const getIndicatorProps = (value, compareTo) => {
    const isPositive = value >= 0;
    let color = isPositive ? '#2e7d32' : '#d32f2f'; 
    if (isPositive && compareTo !== undefined && value < compareTo) {
      color = '#df7a00';
    }
    const ArrowIcon = isPositive ? ArrowUpwardIcon : ArrowDownwardIcon;
    console.log(value)
    return {
      color,
      ArrowIcon,
      formattedValue: `${isPositive ? '+' : ''}${value.toFixed(1)}%`
    };
  };

  const firstProps = getIndicatorProps(firstValue, secondValue);
  const secondProps = getIndicatorProps(secondValue);

  const getLabels = () => {
    if (displayMode === "manufacturer") {
      return {
        firstLabel: getUserDisplayName(),
        secondLabel: "Market"
      };
    } else {
      return {
        firstLabel: "Market Growth",
        secondLabel: selectedLabel || "Selected Filter"
      };
    }
  };

  const { firstLabel, secondLabel } = getLabels();

  return (
    <Paper
      elevation={0}
      sx={{
        height: 200,
        display: 'flex-start',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {/* Title */}
      <Typography
        sx={{
          mb: 2,
          fontSize: "14px",
          fontWeight: "bold",
          color: "#263238",
          textAlign: 'center',
        }}
      >
        {title}
      </Typography>

      {/* First Value */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: "column",
          gap: 1,
          mb: 2,
          mt: 2,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: '#666',
            fontWeight: 500,
            fontSize: '14px',
          }}
        >
           {firstLabel}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <firstProps.ArrowIcon
            sx={{
              fontSize: 20,
              color: firstProps.color,
            }}
          />
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 700,
              color: firstProps.color,
            }}
          >
            {firstProps.formattedValue}
          </Typography>
        </Box>
      </Box>

      {/* Competitor Value */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: "column",
          gap: 0.5,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: '#666',
            fontWeight: 500,
            fontSize: '14px',
          }}
        >
          {secondLabel}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <secondProps.ArrowIcon
            sx={{
              fontSize: 20,
              color: secondProps.color,
            }}
          />
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 700,
              color: secondProps.color,
            }}
          >
            {secondProps.formattedValue}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default ValueGrowthIndicator;